import React, { useState } from 'react';

const BtnExtraReadRemind = ({
  onClick = () => {},
}) => {
  const [show, setShow] = useState(true);

  if (!show) return '';

  return (
    <div
      className="text-right position-sticky"
      style={{ bottom: '180px', height: 0 }}
    >
      <a
        className="
          btn btn-tertiary text-white btn-sm rounded-pill text-center
          px-3 shadow-float
        "
        onClick={() => {
          setShow(false);
          onClick();
        }}
      >
        下拉查看延伸學習
        <br/>
        ↓
      </a>
    </div>
  );
};

export default BtnExtraReadRemind;
